<ion-list lines="none" id="login-form-list">
  
  <div id="bb-info">
    <img src="assets/image/bb-logo.png"alt="" height="50"/>
    <p>Already have a Bid Beacon account? Use the same username and password!</p>
  </div>
  
  <app-email-input id="username" [(ngModel)]="model.username" [required]="true" label="Email Address"></app-email-input>

  <div style="display:grid;grid-template-columns: 1fr 50px;">
    <app-password-input id="password" [(ngModel)]="model.password" [required]="true" label="Password" [show]="showPwd"></app-password-input>
    <ion-icon [name]="showPwd ? 'eye-outline' : 'eye-off-outline'" style="font-size:1.5em;margin:38px 0 0 15px;cursor:pointer;" (click)="showPwd = !showPwd"></ion-icon>
  </div>

  <app-text-input id="firstName" [(ngModel)]="model.firstName" [required]="true" label="First Name"></app-text-input>

  <app-text-input id="lastName" [(ngModel)]="model.lastName" [required]="true" label="Last Name"></app-text-input>

  <!--app-phone-input id="phonenumber" [(ngModel)]="model.phoneNumber" [required]="false" label="Phone Number"></app-phone-input-->
 

  <div *ngIf="pageState.busy === false" class="mt20px">
    <ion-button id="register-btn" size="block" shape="round" (click)="register()">Create Account</ion-button>
    <ion-button class="link-btn" fill="clear" size="block" (click)="login()">Cancel</ion-button>
  </div>

  <div class="ion-text-center" [hidden]="!pageState.busy">
    <ion-spinner name="dots" color="login-color"></ion-spinner>
  </div>
</ion-list>